import "../css/style.css"

// Our modules / classes
import MyNotes from "./modules/MyNotes"

// const googleMap = new GoogleMap()
const myNotes = new MyNotes()

